module.exports = __webpack_public_path__ + "static/media/Ysb-mobile.7d3dedd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/campaign/Ysb-mobile.jpg
// module id = 1551
// module chunks = 0